module.exports = __webpack_public_path__ + "static/media/new-img3.1310917e.png";